import { Options } from 'signature_pad';
import { SignaturePadConfigDefault, SignaturePadOutputFileType } from './signature-pad.constant';

export function getSignaturePadConfigDefault(outputType: SignaturePadOutputFileType): Options {
  return SignaturePadConfigDefault[outputType] || {};
}
